<template>
  <div id="main-footer">
    <div class="container">
      <section>
        <div class="links">
          <div class="links-wrapper">
            <div class="projects">
              <h3 @click="openProject = !openProject">
                Projects
                <span class="toggle-nav">{{ openProject ? "-" : "+" }}</span>
              </h3>
              <ul v-if="openProject">
                <li>
                  <a href="https://insight.upmood.com" target="_blank"
                    >Upmood Insight</a
                  >
                </li>
                <li>
                  <a href="https://www.upmooddesignlab.com" target="_blank"
                    >Upmood designlab</a
                  >
                </li>
                <li>
                  <a :href="iframeSrc" target="_blank">Charles' Emotion</a>
                </li>
              </ul>
            </div>

            <div class="about">
              <h3 @click="openAbout = !openAbout">
                About
                <span class="toggle-nav">{{ openAbout ? "-" : "+" }}</span>
              </h3>
              <ul v-if="openAbout">
                <li>
                  <span @click="changeRoute('/TermsAndConditions')"
                    >Terms and Condition</span
                  >
                </li>
                <li>
                  <span @click="changeRoute('/PrivacyPolicy')"
                    >Privacy Policy</span
                  >
                </li>
                <li>
                  <span @click="changeRoute('/CookiesPolicy')"
                    >Cookies Policy</span
                  >
                </li>
                <li>
                  <span @click="changeRoute('/WarrantyPolicy')"
                    >Warranty Policy</span
                  >
                </li>
              </ul>
            </div>

            <div class="help">
              <h3 @click="openHelp = !openHelp">
                Help
                <span class="toggle-nav">{{ openHelp ? "-" : "+" }}</span>
              </h3>
              <ul v-if="openHelp">
                <li>
                  <span @click="changeRoute('/ContactUs')">Contact Us</span>
                </li>
                <li>
                  <span @click="changeRoute('/Troubleshoot')">Support</span>
                </li>
              </ul>
            </div>

            <!-- <div class="contact-us">
                    <h3 @click="openContact = !openContact">
                    Contact Us
                    <span class="toggle-nav">{{ openContact ? "-" : "+" }}</span>
                    </h3>
                    <ul v-if="openContact">
                    <li>Tel. +852 23699788</li>
                    <li>
                        Address: Taison Digital Ltd. Unit 29, 18/F, Block B, Wah Lok
                        Ind. Centre, 37－41 Shan Mei Street, Fo Tan, Shatin, N.T.
                    </li>
                    </ul>
                </div> -->
          </div>

          <footer>
            <a href="https://www.facebook.com/UpmoodApp" target="blank"
              ><img src="@/assets/img/facebook.svg" alt="facebook"
            /></a>
            <a href="https://twitter.com/Upmoodapp" target="blank"
              ><img src="@/assets/img/twitter.svg" alt="twitter"
            /></a>
            <a href="https://www.instagram.com/upmoodapp" target="blank"
              ><img src="@/assets/img/instagram.svg" alt="instagram"
            /></a>
            <p>&copy; 2021, Taison Digital. All rights reserved</p>
          </footer>
        </div>

        <div class="subscribe">
          <h3>Subscribe</h3>
          <p class="details">
            Subscribe to our newsletter, so that you can be the first to know
            about new offers and promotions.
          </p>
          <form class="input-wrapper" @submit.prevent="subscribe">
            <input
              type="text"
              placeholder="Enter Email Address"
              required
              v-model="email"
              :disabled="sending"
            />
            <button class="button-cyan" type="submit" :disabled="sending">
              {{ sending ? "..." : "Subscribe" }}
            </button>
          </form>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      email: "",
      openProject: false,
      openAbout: false,
      openHelp: false,
      openContact: false,

      iframeSrc: `${process.env.VUE_APP_MOODMIX_URL.replace(
        "moodmix",
        process.env.VUE_APP_SERVER === "beta" ? "betainsight" : "insight"
      )}/user-display?session_id=417&language=english&count=10&page=1&active_level=online&view=user`
    };
  },

  computed: {
    ...mapGetters({
      sending: "newsletter/sending",
      response: "newsletter/response"
    })
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    async subscribe() {
      this.email = this.email.trim();
      if (!this.email || !this.email.length) return;

      this.$store.commit("newsletter/TOGGLE_SENDING", true);
      const isEmailVerified = await this.$options.filters.verifyEmail(
        this.email
      );
      if (!isEmailVerified) {
        await this.$store.dispatch("alert/setContent", {
          title: "Sorry",
          message: "Email not valid!",
          button: "Close",
          hasError: true
        });
        this.$store.commit("newsletter/TOGGLE_SENDING", false);
        this.$store.dispatch("alert/toggleAlert", true);
        return;
      }
      let formData = new FormData();
      formData.append("email", this.email);
      await this.$store.dispatch("newsletter/subscribe", formData);
      if (this.response.data && this.response.data.status === 200) {
        await this.$store.dispatch("alert/setContent", {
          title: "Success",
          message: "Successfully subscribed to newsletter.",
          button: "Awesome",
          hasError: false
        });
        this.email = "";
        this.$store.dispatch("alert/toggleAlert", true);
        return;
      }
      if (this.response.data.status == 422) {
        await this.$store.dispatch("alert/setContent", {
          title: "Sorry",
          message: this.response.data.errors.email[0],
          button: "Close",
          hasError: true
        });
        this.$store.dispatch("alert/toggleAlert", true);
        return;
      }
      await this.$store.dispatch("alert/setContent", {
        title: "Sorry",
        message: "Something went wrong!",
        button: "Close",
        hasError: true
      });
      this.$store.dispatch("alert/toggleAlert", true);
    },

    gotoInsight() {
      window.open(this.iframeSrc, "_blank");
    },

    changeRoute(route) {
      if (window.innerWidth <= 590) {
        this.openProject = false;
        this.openAbout = false;
        this.openHelp = false;
        this.openContact = false;
      }
      this.$router.push(route).catch(() => {});
    },

    handleResize() {
      this.openProject = window.innerWidth > 590;
      this.openAbout = window.innerWidth > 590;
      this.openHelp = window.innerWidth > 590;
      this.openContact = window.innerWidth > 590;
    }
  }
};
</script>

<style lang="scss" scoped>
#main-footer {
  z-index: +1;
  background-color: #fff;
  color: #6b7a80;
  padding: 60px 0px;
  //   padding-bottom: 50px;
  position: relative;
  font-family: $Lato;
  border-top: 1px solid #e2e2e2;

  @include mobile {
    padding: 25px 0px;
  }

  a {
    color: #6b7a80;
    text-decoration: none;
  }

  .container {
    display: relative;
    width: 100%;

    .newsletter-wrapper {
      position: absolute;
      width: 1024px;
      top: -95px;
      left: 50%;
      transform: translateX(-50%);

      @include mobile {
        width: 100%;
        top: -40px;
      }
    }

    section {
      display: flex;
      justify-content: center;

      @include mobile {
        flex-direction: column-reverse;
        padding: 0;
      }

      .links {
        display: flex;
        flex-direction: column;

        .links-wrapper {
          display: flex;
          margin-bottom: 100px;

          @include mobile {
            flex-direction: column;
          }
        }

        .projects,
        .about,
        .help,
        .contact-us {
          margin-right: 80px;

          @include mobile {
            margin: 0px;
            padding: 15px 0px;
            border-bottom: 1px solid #ebebeb;
          }
        }

        .contact-us {
          width: 250px;

          @include mobile {
            width: 100%;
          }
        }

        h3 {
          position: relative;
          margin-bottom: 30px;
          font-size: 16px;
          font-weight: bold;
          line-height: 19px;
          pointer-events: none;

          @include mobile {
            margin-bottom: 5px;
            cursor: pointer;
            pointer-events: auto;
          }

          .toggle-nav {
            display: none;
            @include mobile {
              display: block;
              position: absolute;
              right: 0;
              top: 0;
            }
          }
        }

        ul {
          list-style: none;

          @include mobile {
            box-shadow: 0px 4px 3px #00000029;
            padding: 20px 15px;
          }

          li {
            margin-bottom: 15px;
            font-size: 14px;
            line-height: 17px;

            span {
              cursor: pointer;
            }

            &:last-child {
              margin-bottom: 0px;
            }
          }
        }
      }

      .subscribe {
        max-width: 380px;

        @include mobile {
          margin-bottom: 25px;
          max-width: 100%;
        }

        h3 {
          margin-bottom: 30px;
          font-size: 16px;
          font-weight: bold;
          line-height: 19px;
        }
        .details {
          font-weight: 400;
          color: #6b7a80;
          margin-bottom: 15px;
        }
        .input-wrapper {
          width: 100%;
          display: flex;
          flex-direction: row;
        }

        input,
        button {
          padding: 10px 15px;
          border: none;
          outline: none;
          font-size: 0.8em;
        }

        button {
          min-width: 120px;
          border-radius: 0px 3px 3px 0px;
        }

        input {
          flex: 1 1 auto;
          border-radius: 3px 0px 0px 3px;
          border: 1px solid #c4c8c9;
        }
      }
    }

    footer {
      display: flex;
      font-size: 14px;
      line-height: 19px;
      padding-top: 20px;
      text-align: left;
      color: #6b7a80;

      @include mobile {
        display: block;
      }

      a {
        img {
          width: 13px;
          margin-right: 10px;
        }
      }

      p {
        margin-left: 20px;
        font-family: $OpenSans;

        @include mobile {
          margin: 10px 0;
        }
      }
    }
  }
}
</style>
